import { createFileRoute } from '@tanstack/react-router'
import { AssetTypesSection } from '../../../features/service/sites/asset-types-section'
import { requireSection } from '../../../features/settings/guards'

export const Route = createFileRoute('/_app/settings/service-asset-types')({
  staticData: { crumb: 'settingsSection' },
  beforeLoad: ({ context }) => requireSection(context.session, 'service-asset-types'),
  component: AssetTypesSection,
})
